import React from 'react';

const MobileDrawer = ({ isMenuOpen, setIsMenuOpen, scrollTo }) => {
  return (
    <div 
      className={`fixed inset-0 z-[60] transition-opacity duration-300 ${isMenuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}
    >
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={() => setIsMenuOpen(false)}></div>
      <div 
        className={`absolute right-0 top-0 h-full w-[280px] bg-emerald-950/98 z-[70] transform transition-transform duration-300 ease-in-out shadow-2xl ${isMenuOpen ? 'translate-x-0' : 'translate-x-full'} flex flex-col p-8 pt-20`}
      >
        <button 
          className="absolute top-6 right-6 text-white text-2xl p-2"
          onClick={() => setIsMenuOpen(false)}
        >
          <i className="fas fa-times"></i>
        </button>

        <ul className="flex flex-col space-y-6 text-xl text-white font-medium text-left">
          <li>
            <button onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); setIsMenuOpen(false); }} className="flex items-center gap-3">
              <i className="fas fa-home text-sm opacity-50"></i> Home
            </button>
          </li>
          <li>
            <button onClick={() => { scrollTo('accommodations'); setIsMenuOpen(false); }} className="flex items-center gap-3">
              <i className="fas fa-bed text-sm opacity-50"></i> Our Stays
            </button>
          </li>
          <li>
            <button onClick={() => { scrollTo('wonders'); setIsMenuOpen(false); }} className="flex items-center gap-3">
              <i className="fas fa-mountain text-sm opacity-50"></i> Wonders
            </button>
          </li>
          <li>
            <button onClick={() => { scrollTo('contact'); setIsMenuOpen(false); }} className="flex items-center gap-3">
              <i className="fas fa-envelope text-sm opacity-50"></i> Contact Us
            </button>
          </li>
        </ul>

        <div className="mt-auto pt-10 border-t border-white/10 flex flex-col gap-6">
          <button 
            onClick={() => { scrollTo('contact'); setIsMenuOpen(false); }}
            className="bg-emerald-500 text-emerald-950 font-bold py-4 rounded-xl text-center text-sm uppercase tracking-widest shadow-lg"
          >
            BOOK NOW
          </button>
          <div className="flex justify-center gap-6">
            <a href="https://wa.me/919440766328" className="text-emerald-400 text-xl hover:text-white transition"><i className="fab fa-whatsapp"></i></a>
            <button className="text-emerald-400 text-xl hover:text-white transition"><i className="fab fa-instagram"></i></button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileDrawer;
